import { endpoint } from '../decorators';
import { BaseViewModel } from './base-view-model';

@endpoint('Correspondence')
export class CorrespondenceInputModel extends BaseViewModel {
  /** This could be an email correspondence subject line, or intake staff's own title. */
  public Title = '';

  /** Could be the body of the email correspondence, or intake staff's summary. */
  public Summary = '';
  public RequestorName = '';
  public RequestorDetail = '';

  /** A short description of the correspondence source. E.g., email, text, phone, letter, news article, etc */
  public ReceivedThrough = '';

  public Status = '';

  /** When the University received the correspondence. */
  public DateReceived: Date = null;

  /** When a reply is due, if ever. */
  public DueDate: Date = null;
}
